import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Alert, Box, Button, Container, Paper, Snackbar, Card, CardContent, Divider, Chip, IconButton, Tooltip } from '@mui/material';
import { ArrowBack, ContentCopy, QrCode, CheckCircle, Pending, Cancel, Phone, Person, Description, AccessTime, AttachMoney, Fingerprint } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios';
import { url } from '../utils/constants';
import { LoaderOverlay } from '../utils/components';
import QRCode from 'qrcode.react';



export default function PagamentoDetalhado({ usePageTitle }) {
  usePageTitle('PixTick | Transação detalhada');
  const id = useLocation().pathname.split('/').pop();
  const [transaction, setTransaction] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [copied, setCopied] = React.useState(false);
  const navigate = useNavigate();


  React.useEffect(() => {
    async function fetchData() {
      try {
        const token = await localStorage.getItem('token');
        //console.log('teste> ' + token);
        const response = await axios.get(url + `/api/v1/pagamento/${id}`, {
          headers: ({
            Authorization: 'Bearer ' + token
          })
        });
        const { data } = response.data;
        setTransaction(data);

        //console.log(data);

        // Usuário logado
      } catch {
        // Usuário não logado
        //navigate('/signin');
      } finally {
        setLoading(false);
        //console.log(transactions);

      }

    }
    fetchData();
  }, [navigate, transaction._id, id]);





  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return phoneNumber;

    // Definir máscaras para cada DDI
    const masks = {
      '+55': { name: 'Brasil', mask: '(xx) xxxxx-xxxx' },
      '+54': { name: 'Argentina', mask: '(x) xxxx xx-xxxx' },
      '+595': { name: 'Paraguai', mask: '(xxx) xxx-xxx' },
      '+1': { name: 'EUA', mask: '(xxx) xxx-xxxx' }
      // Adicione outras máscaras conforme necessário
    };

    // Detectar o DDI do número de telefone
    let ddi = Object.keys(masks).find(ddi => phoneNumber.startsWith(ddi));
    if (!ddi) return phoneNumber; // Se não for encontrado nenhum DDI correspondente, retorne o número de telefone sem formatação
    phoneNumber = phoneNumber.replace(ddi, ''); // Remover o DDI do número de telefone
    // Obter a máscara correspondente ao DDI detectado
    const mask = masks[ddi].mask;

    // Remover caracteres não numéricos do número de telefone
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Aplicar máscara ao número de telefone
    let formattedPhoneNumber = '';
    let maskIndex = 0;
    for (let i = 0; i < mask.length && maskIndex < numericPhoneNumber.length; i++) {
      if (mask[i] === 'x') {
        formattedPhoneNumber += numericPhoneNumber[maskIndex];
        maskIndex++;
      } else {
        formattedPhoneNumber += mask[i];
      }
    }
    //ddi + formattedPhoneNumber;

    return ddi + ' ' + formattedPhoneNumber;
  }

  const formatCurrency = (value) => {
    if (!value) return value;

    // Formata o valor em moeda brasileira (pt-BR)
    return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  function getStatusConfig(status) {
    switch (status) {
      case 'Pendente':
        return { color: '#1976D2', backgroundColor: '#E3F2FD', icon: <Pending />, label: 'Pendente' };
      case 'PAGO':
        return { color: '#4CAF50', backgroundColor: '#E8F5E8', icon: <CheckCircle />, label: 'Pago' };
      case 'Concluído':
        return { color: '#4CAF50', backgroundColor: '#E8F5E8', icon: <CheckCircle />, label: 'Concluído' };
      case 'Falhou':
        return { color: '#F44336', backgroundColor: '#FFEBEE', icon: <Cancel />, label: 'Falhou' };
      default:
        return { color: '#757575', backgroundColor: '#F5F5F5', icon: <Pending />, label: status || 'Desconhecido' };
    }
  }


  const handleVoltar = () => {
    navigate('/relatorio-pagamento');
  }

  const statusConfig = getStatusConfig(transaction.status);

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#F5F5F5',
      paddingTop: { xs: 8, md: 10 }
    }}>
      <Container maxWidth="md">
        <LoaderOverlay loading={loading} />

        {!loading && (
          <>
            {/* Header com botão voltar */}
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton
                onClick={handleVoltar}
                sx={{
                  backgroundColor: '#1976D2',
                  color: 'white',
                  '&:hover': { backgroundColor: '#1565C0' }
                }}
              >
                <ArrowBack />
              </IconButton>
              <Typography variant="h5" fontWeight="bold" color="#1976D2" sx={{ fontSize: { xs: '1.5rem', md: '2rem' } }}>
                Detalhes da Transação
              </Typography>
            </Box>

            {/* Card principal */}
            <Card elevation={4} sx={{ borderRadius: 3, overflow: 'hidden' }}>
              <CardContent sx={{ p: 4 }}>
                {/* Status */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                  <Chip
                    icon={statusConfig.icon}
                    label={statusConfig.label}
                    sx={{
                      backgroundColor: statusConfig.backgroundColor,
                      color: statusConfig.color,
                      fontSize: { xs: '0.9rem', md: '1.1rem' },
                      fontWeight: 'bold',
                      padding: { xs: '8px 16px', md: '12px 24px' },
                      height: 'auto',
                      '& .MuiChip-icon': {
                        fontSize: { xs: '1.2rem', md: '1.5rem' }
                      }
                    }}
                  />
                </Box>

                <Divider sx={{ mb: 3 }} />

                {/* Informações da transação */}
                <Grid container spacing={3}>
                  {/* Valor */}
                  <Grid item xs={12}>
                    <Box sx={{
                      backgroundColor: '#E3F2FD',
                      borderRadius: 2,
                      p: 3,
                      textAlign: 'center',
                      border: '2px solid #1976D2'
                    }}>
                      <Typography variant="h3" fontWeight="bold" color="#1976D2" sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
                        {transaction.amount ? formatCurrency(transaction.amount) : '-'}
                      </Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                        Valor da Transação
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Informações do cliente */}
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ height: '100%' }}>
                      <CardContent>
                        <Typography variant="h6" fontWeight="bold" color="#1976D2" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                          <Person /> Informações do Cliente
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                          <Person color="action" />
                          <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>Nome</Typography>
                            <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                              {transaction.nomeCompleto || '-'}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Phone color="action" />
                          <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>Telefone</Typography>
                            <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                              {transaction.wppNumber ? formatPhoneNumber('+' + transaction.wppNumber) : '-'}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Informações da transação */}
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined" sx={{ height: '100%' }}>
                      <CardContent>
                        <Typography variant="h6" fontWeight="bold" color="#1976D2" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                          <Description /> Detalhes da Transação
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                          <AccessTime color="action" />
                          <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>Data / Hora</Typography>
                            <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                              {transaction.date ? new Date(transaction.date).toLocaleDateString('pt-BR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit'
                              }) : '-'}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                          <Description color="action" />
                          <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>Descrição</Typography>
                            <Typography variant="body1" fontWeight="medium" sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
                              {transaction.description || '-'}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Fingerprint color="action" />
                          <Box>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' } }}>ID Transação</Typography>
                            <Typography variant="body1" fontWeight="medium" sx={{ fontFamily: 'monospace', fontSize: { xs: '0.9rem', md: '1rem' } }}>
                              {transaction.idTransaction || '-'}
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* PIX Code - apenas se pendente */}
                  {transaction.status === 'Pendente' && transaction.pixCopyPaste && (
                    <Grid item xs={12}>
                      <Card variant="outlined" sx={{ backgroundColor: '#F8F9FA' }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold" color="#1976D2" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                            <QrCode /> Código PIX
                          </Typography>

                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: { xs: '0.8rem', md: '0.875rem' } }}>
                            Clique no código abaixo para copiar e realizar o pagamento
                          </Typography>

                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mb: 3,
                            gap: 3,
                            flexDirection: { xs: 'column', md: 'row' },
                            alignItems: 'center'
                          }}>
                            {/* QR Code */}
                            <Box sx={{
                              backgroundColor: 'white',
                              p: 2,
                              borderRadius: 2,
                              boxShadow: 2,
                              border: '1px solid #E0E0E0'
                            }}>
                              <QRCode size={160} value={transaction.pixCopyPaste} />
                            </Box>

                            {/* Código PIX */}
                            <Box sx={{ flex: 1, maxWidth: { xs: '100%', md: '400px' } }}>
                              <Box sx={{
                                backgroundColor: 'white',
                                border: '2px solid #1976D2',
                                borderRadius: 2,
                                p: 2,
                                position: 'relative',
                                cursor: 'pointer',
                                '&:hover': {
                                  backgroundColor: '#F0F8FF'
                                }
                              }}
                                onClick={() => {
                                  navigator.clipboard.writeText(transaction.pixCopyPaste);
                                  setCopied(true);
                                  setTimeout(() => setCopied(false), 2000);
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontFamily: 'monospace',
                                    fontSize: { xs: '0.75rem', md: '0.9rem' },
                                    wordBreak: 'break-all',
                                    color: '#1976D2',
                                    fontWeight: 'medium'
                                  }}
                                >
                                  {transaction.pixCopyPaste}
                                </Typography>
                                <Tooltip title="Copiar código PIX">
                                  <IconButton
                                    size="small"
                                    sx={{
                                      position: 'absolute',
                                      top: 8,
                                      right: 8,
                                      backgroundColor: '#1976D2',
                                      color: 'white',
                                      '&:hover': { backgroundColor: '#1565C0' }
                                    }}
                                  >
                                    <ContentCopy fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </>
        )}

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={copied}
          autoHideDuration={2000}
          onClose={() => setCopied(false)}
        >
          <Alert onClose={() => setCopied(false)} severity="success" sx={{ width: '100%' }}>
            Código PIX copiado com sucesso!
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );

}
